import { PreValidation } from "models/batch/PreValidation";
import { Question, ResponseType } from "models/batch/Question";
import { QuestionResponse } from "models/batch/QuestionResponse";

export enum AttributePolicy {
    Public = 1,
    Private = 3,
    Hidden = 4,
    SMEVisible = 5
}

export type AttributeSettings = {
    filterByDealBreaker: boolean;
}

export enum MatchType {
    Empty = 0,
    Exact = 1,
    Partial = 2,
    NoMatch = 3,

}

export class Attribute {
    id: number;
  
    name: string;
  
    defaultPolicy: AttributePolicy;
  
    attributeGroup: string;
  
    isSensitive: boolean;
  
    created: Date;
  
    createdBy: number;
  
    updated: Date;
  
    updatedBy: number;
  
    txtId: string;
    txt: string;
  
    editingQuestionId: number;
  
    userEditable: boolean;
  
    assetId: string;
  
    sensitiveAlternativeExp: string;
  
    attributeCategory: string;
  
    ordinal: number;
  
    extendedInfoTxtId: string;
  
    preValidation: PreValidation[];
  
    userToggleable: boolean;
  
    relatedBatchId: number;
  
    isFeatured: boolean;
  
    brandId: number;
  
    questions: Question[];
    
    responses: QuestionResponse[];

    settings: AttributeSettings;

    get responseType() : ResponseType {
        return this.questions?.[0]?.responseType;
    }
  }
  